/**
 * The anonymous device account.
 *
 * The identity model is deliberately minimal: a random opaque id in
 * localStorage, no email, no sign-in. It is what a 1v1 room uses to tell the
 * two players apart, and what lets someone reload mid-match and land back in
 * their own room rather than being told it is full.
 *
 * The same key the analytics beacon uses, on purpose. Two independent ids would
 * mean a room and its analytics could never be correlated when debugging a
 * disputed match — and there is no privacy gained by having two random strings
 * instead of one.
 */

const KEY = 'p11.did';

function randomId(): string {
  const bytes = new Uint8Array(9);
  crypto.getRandomValues(bytes);
  let out = '';
  for (const b of bytes) out += b.toString(36).padStart(2, '0');
  return out.slice(0, 64);
}

let cached = '';

export function deviceId(): string {
  if (cached) return cached;
  try {
    const stored = localStorage.getItem(KEY);
    if (stored) {
      cached = stored;
      return cached;
    }
    cached = randomId();
    localStorage.setItem(KEY, cached);
  } catch {
    // Private mode, or storage disabled. A session-lived id still lets a room
    // work until the tab closes, which beats refusing to play.
    cached = cached || randomId();
  }
  return cached;
}
